import { render } from "./NftHistory.vue?vue&type=template&id=2678ceeb&scoped=true"
import script from "./NftHistory.vue?vue&type=script&lang=js"
export * from "./NftHistory.vue?vue&type=script&lang=js"

import "@/Common/Styles/nftHistory.scss?vue&type=style&index=0&id=2678ceeb&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2678ceeb"]])

export default __exports__